import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, RouterLink],
})
export class NotFoundComponent implements AfterViewInit {
  private readonly _router = inject(Router);
  private readonly _previousUrl = this._safePreviousUrl();

  @ViewChild('pageHeading', { static: true })
  private _pageHeading!: ElementRef<HTMLHeadingElement>;

  readonly canGoBack = this._previousUrl !== null;

  ngAfterViewInit(): void {
    this._pageHeading.nativeElement.focus();
  }

  goBack(): void {
    if (this._previousUrl) {
      void this._router.navigateByUrl(this._previousUrl);
    }
  }

  private _safePreviousUrl(): string | null {
    const previousUrl = this._router
      .getCurrentNavigation()
      ?.previousNavigation?.finalUrl?.toString();

    return previousUrl && !previousUrl.startsWith('/not-found')
      ? previousUrl
      : null;
  }
}
